import React, { useState } from 'react';
import Modal from "../common/Modal/Modal";
import "./Decision.scss";
import Button from '../../../partials/Button'
function Decision({show = false,
                      sensor,
                      onCancel = () => {},
                      onSelect= () => {},
                      missionRequirements = '',
                      missionRequirementsText = '',
                      closeButtonText = ''
                  }) {

    const [ mReqDialogShow, setMReqDialogShow ] = useState(false);

    if (!sensor) {
        return null
    }
    return (!mReqDialogShow?<Modal show={ show } size={'medium'}
                  showContinue={false}
           >
           <div className={'decision-container'} >
               <div>
               <div className={'decision-title'}>
                   { sensor.type }
               </div>
               <div className={"decision-missionparameters-button-container"} >
                       <Button text={missionRequirementsText} variant="toRight" onClick={() => {
                            setMReqDialogShow(true);
                           }}/>
                   </div>
               </div>
               <div className={'decision-summary'} >
                   <div className={"decision-img-container"} >
                       <img src={sensor.img} className={'decision-img'}  alt={sensor.type}/>
                   </div>
                    <div className={"decision-sensor-question"}> 
                    <div style={{textAlign:"center",marginBottom:"2rem"}}>{sensor.decisionSensorQuestion}</div>
                    <div style={{display:"flex", gap:".1rem"}}>
                        <Button text={sensor.rejectCaption} onClick={ () => {
                       if (onCancel) {
                           onCancel();
                       }
                   }}/>
                     <Button text={sensor.acceptCaption} onClick={ () => {
                      if (onSelect) {
                          onSelect()
                      }
                  }}/>
                   </div></div>
                  
               </div>

           </div>
    </Modal>: <div className="mission-requirement-decision"><Modal
                    size={'medium'}
                    show={mReqDialogShow}
                    showContinue={false}
                   >
                        <div dangerouslySetInnerHTML={{ __html: missionRequirements}}></div>
                        <div style={{textAlignLast:"center"}}>
                            <Button text={closeButtonText} onClick={()=>setMReqDialogShow(false)}/>
                        </div>
                   </Modal></div>)
}
export default Decision;
